import {ILocal} from "../helpers/localization";

const local_en:ILocal = {
    'test': 'test_en',
    'Dashboard': 'Dashboard',
    'Requests': 'Requests',
    'Meetings': 'Meetings',
    'Accounts': 'Accounts',
    'Customers': 'Customers',
    'System logs': 'System logs',
    'Received on': 'Received on',
    'First name': 'First name',
    'Last name': 'Last name',
    'Organization': 'Organization',
    'Email': 'Email',
    'Phone number': 'Phone number',
    'Contact request': 'Contact request',
    'Contact requests': 'Contact requests',
    'Delete': 'Delete',
    'Save': 'Save',
    'Transmit': 'Transmit',
    'Delete this contact requests?': 'Delete this contact requests?',
    'Birthdate': 'Birthdate',
    'Civil status': 'Civil status',
    'Single': 'Single',
    'Spouse': 'Spouse',
    'Maried': 'Maried',
    'Divorced': 'Divorced',
    'Widow(er)': 'Widow(er)',
    'Address': 'Address',
    'Postal code': 'Postal code',
    'Cell Phone': 'Cell Phone',
    'Phone at work': 'Phone at work',
    'Phone at home': 'Phone at home',
    'Organization link': 'Organization link',
    'Child': 'Child',
    'Employee': 'Employee',
    'Employee name': 'Employee name',
    'Employee status': 'Employee status',
    'Employee time': 'Employee time',
    'Executive': 'Executive',
    'Syndicated': 'Syndicated',
    'Permanent': 'Permanent',
    'Part-time': 'Part-time',
    'TPO': 'TPO',
    'Temporary': 'Temporary',
    'Contractual': 'Contractual',
    'Retired': 'Retired',
    'This action will archive this contact request for 10 days. After this period, it will be removed forever. Do you want to continue?': 'This action will archive this contact request for 10 days. After this period, it will be removed forever. Do you want to continue?',
    'Requested service': 'Requested service',
    'Employee Assistance Program (EAP)': 'Employee Assistance Program (EAP)',
    'Psychology/social work service CNESST, IVAC, Health Canada, Blue Cross, other': 'Psychology/social work service CNESST, IVAC, Health Canada, Blue Cross, other',
    'Private Psychology/Social Work Service': 'Private Psychology/Social Work Service',
    'Neuropsychology Service': 'Neuropsychology Service',
    'Private ABC Clinic Service': 'Private ABC Clinic Service',
    'Mediation service, conflict resolution at work, psychological harassment and others in between': 'Mediation service, conflict resolution at work, psychological harassment and others in between',
    'Used service past': 'Used service past',
    'Yes': 'Yes',
    'No': 'No',
    'Directed by': 'Directed by',
    'EAP Advertising': 'EAP Advertising',
    'Doctor\'s recommendation': 'Doctor\'s recommendation',
    'IVAC': 'IVAC',
    'Suggestion from a colleague/friend': 'Suggestion from a colleague/friend',
    'Employer recommendation': 'Employer recommendation',
    'SAAQ': 'SAAQ',
    'Suggestion from the family': 'Suggestion from the family',
    'Union recommendation': 'Union recommendation',
    'Quebec government': 'Quebec government',
    'Already viewed': 'Already viewed',
    'CNESST': 'CNESST',
    'Health Canada': 'Health Canada',
    'Comments': 'Comments',
    'Communications': 'Communications',
    'Add communication': 'Add communication',
    'Request received': 'Request received',
    "Menu": "Menu",
    "Patients": "Patients",
    "Name": "Name",
    "Status": "Status",
    "Contracts": "Contracts",
    "Account": "Account",
    "Opened on": "Opened on",
    "Closed on": "Closed on",
    "Employee's meets": "Employee's meets",
    "Spouse's meets": "Spouse's meets",
    "Children's meets": "Children's meets",
    "Deactivate this account?": "Deactivate this account?",
    "Are you sure you want to deactivate this account?": "Are you sure you want to deactivate this account?",
    "Are you sure you want to deactivate this patient?": "Are you sure you want to deactivate this patient?",
    "Are you sure you want to reactivate this patient?": "Are you sure you want to reactivate this patient?",
    "Change theme": "Change theme",
    "Profile": "Profil",
    "Log out": "Log out",
    "Active": "Active",
    "Edit": "Edit",
    "Notifications": "Notifications",
    "Deactivate": "Deactivate",
    "Reactivate": "Reactivate",
    "Patient": "Patient",
    "Communicate by": "Communicate by",
    "Communication's result": "Communication's result",
    "Cancel": "Cancel",
    "Successfully saved": "Successfully saved",
    "An error occurred, please try again": "An error occurred, please try again",
    "Meeting follow up": "Meeting follow up",
    "Duration": "Duration",
    "Created": "Created",
    "Completed": "Completed",
    "Missed": "Missed",
    "Reported": "Reported",
    "Canceled": "Canceled",
    "date": "date",
    "from": "from",
    "to": "to",
    "No patient found": "No patient found",
    "Professional": "Professional",
    "Note": "Note",
    "Configurations": "Configurations",
    "Meeting": "Meeting",
    "Start typing to search": "Start typing to search",
    "Unsaved changes": "Unsaved changes",
    "All unsaved changes will be lost. Do you want to continue?": "All unsaved changes will be lost. Do you want to continue?",
    "Link Patient": "Link Patient",
    "One or more patient correspond to the contact request. Please select the patient to set the meeting or click on \"Create new patient\"": "One or more patient correspond to the contact request. Please select the patient to set the meeting or click on \"Create new patient\"",
    "Create new patient": "Create new patient",
    "All": "All",
    "None": "None",
    "Follow up": "Follow up",
    "Confirm presence": "Confirm presence",
    "Cancel the meeting": "Cancel the meeting",
    "Are-you sure you want to cancel this meeting?": "Are-you sure you want to cancel this meeting?",
    "Patient history": "Patient history",
    "There is no previous meeting for this patient": "There is no previous meeting for this patient",
    "Meeting duration": "Meeting duration",
    "Follow up completed": "Follow up completed",
    "Close": "Close",
    "No notifications": "No notifications",
    "On the patient's account": "On the patient's account",
    "This meeting is at charge of the patient.": "This meeting is at charge of the patient.",
    "Please ask for payment before the meeting.": "Please ask for payment before the meeting.",
    "EMPLOYEE": "Employee",
    "SPOUSE": "Spouse",
    "CHILD": "Child",
    "There is no remaining meetings for this patient.": "There is no remaining meetings for this patient.",
    "Please change the meeting to be at charge of the patient.": "Please change the meeting to be at charge of the patient.",
    "Remaining meetings": "Remaining meetings",
    "Previous meetings": "Previous meetings",
    "Presence confirmed": "Presence confirmed",
    "Start": "Start",
    "Stop": "Stop",
    "Print": "Print",
    "Meeting Follow up": "Meeting Follow up",
    "SINGLE": "Single",
    "MARIED": "Maried",
    "DIVORCED": "Divorced",
    "WIDOWER": "Widower",
    "EXECUTIVE": "Executive",
    "SYNDICATED": "Syndicated",
    "PERMANENT": "Permanent",
    "PARTTIME": "Part time",
    "TEMPORARY": "Temporary",
    "CONTRACTUAL": "Contractual",
    "RETIRED": "Retired",
    "SERVICES_EAP": "Employee Assistance Program (EAP)",
    "SERVICES_WORK": "Psychology/social work service CNESST, IVAC, Health Canada, Blue Cross, other",
    "SERVICES_PRIVATE": "Private Psychology/Social Work Service",
    "SERVICES_NEURO": "Neuropsychology Service",
    "SERVICES_ABC": "Private ABC Clinic Service",
    "SERVICES_MEDIATION": "Mediation service, conflict resolution at work, psychological harassment and others",
    "YES": "Yes",
    "NO": "No",
    "DOCTOR": "Doctor's recommendation",
    "SUGGESTION_FRIEND": "Suggestion from a colleague/friend",
    "RECOMMENDATION_EMPLOYER": "Employer recommendation",
    "SUGGESTION_FAMILY": "Suggestion from the family",
    "RECOMMENDATION_UNION": "Union recommendation",
    "GVT_QC": "Quebec government",
    "ALREADY_VIEWED": "Already consulted",
    "GVT_CA": "Health Canada",
    "Reports": "Reports",
    "EAP_AD": "EAP Advertising",
    "RECOMMENDATION_DOCTOR": "Doctor's recommendation",
    "Give access": "Give access",
    "Remove the access": "Remove the access",
    "Assistant": "Assistant",
    "Administrator": "Administrator",
    "Users": "Users",
    "Role": "Role",
    "Last access": "Last access",
    "Invite user": "Invite user",
    "Meetings list": "Meetings list",
    "From": "From",
    "To": "To",
    "Run report": "Run report",
    "Coming": "Coming",
    "Missing follow-up": "Missing follow-up",
    "Done": "Done",
    "Waiting": "Waiting",
    "Deleted": "Deleted",
    "Scheduled": "Scheduled",
    "Meetings requests": "Meetings requests",
    "Restore the meeting": "Restore the meeting",
    "Are-you sure you want to restore this meeting?": "Are-you sure you want to restore this meeting?",
    "Date": "Date",
    "User": "User",
    "Request url": "Request url",
    "Request body": "Request body",
    "Action": "Action",
    "Logs": "Logs",
    "Request body copied to clipboard": "Request body copied to clipboard",
    "Schedule": "Schedule",
    "Schedule exceptions": "Schedule exceptions",
    "End": "End",
    "Working": "Working",
    "Add": "Add",
    "Remove": "Remove",
    "File number": "File number",
    "Schedule a follow-up appointment": "Schedule a follow-up appointment",
    "Follow-up": "Follow-up",
    "Validated previous session": "Validated previous session",
    "Created a meeting": "Created a meeting",
    "Changed a status meeting": "Changed a status meeting",
    "Created a patient": "Created a patient",
    "Changed a user role": "Changed a user role",
    "Updated a patient": "Updated a patient",
    "Number of meetings": "Number of meetings",
    "Number of professionals": "Number of professionals",
    "Password": "Password",
    "Forgot password": "Forgot password",
    "Sign in": "Sign in",
    "Remember your password?": "Return to sign in",
    "Have a code?": "I have a code",
    "Get a password reset code": "Get a password reset code",
    "Code": "Code",
    "Reset password": "Reset password",
    "Bad email or password": "Bad email or password",
    "If this email has access, you will receive a reset code.": "If this email has access, you will receive a reset code.",
    "An email has been sent with the new password": "Un courriel vous a été envoyé avec le nouveau mot de passe",
    "The reset code is not valid": "The reset code is not valid",
    "Auto save": "Auto save",
    "Note model": "Note model",
    "Apply note model?": "Apply note model?",
    "You will lost any entered note. Do you want to continue?": "You will lost any entered note. Do you want to continue?",
    "Email notifications": "Email notifications",
    "SMS notifications": "SMS notifications",
    "Use a contract extension": "Use a contract extension",
    "There is no remaining meetings left. Can this patient use a contract extension?": "There is no remaining meetings left. Can this patient use a contract extension?",
    "Professional not available": "Professional not available",
    "The professional is not available at this schedule. Are you sure you want to schedule this meeting?": "The professional is not available at this schedule. Are you sure you want to schedule this meeting?",
    "View": "View",
    "Extension": "Extension",
    "To come": "To come",
    "Confirmed": "Confirmed",
    "View deleted contact requests": "View deleted contact requests",
    "Add schedule exception": "Add schedule exception",
    "This meeting is on a contract extension.": "This meeting is on a contract extension.",
    "Please make sure you have permission to schedule this meeting.": "Please make sure you have permission to schedule this meeting.",
    "You must pass a two-factor authentication to continue": "You must pass a two-factor authentication to continue",
    "Obtain code by SMS": "Obtain code by SMS",
    "Obtain code by Email": "Obtain code by email",
    "A code has been sent to": "A code has been sent to",
    "Validate": "Validate",
    "The two-factor authentication is not valid": "The two-factor authentication is not valid",
    "Phone": "Phone",
    "Send": "Send",
    "Meeting date": "Meeting date",
    "Special account": "Special account",
    "Ensure that you're authorized to set this meeting on the special account!": "Ensure that you're authorized to set this meeting on the special account!",
    "A cycle report must be uploaded": "A cycle report must be uploaded",
    "Color": "Color",
    "Choose a color": "Choose a color",
    "CSST": "CSST",
    "DOCUMENT": "DOCUMENT",
    "Request": "Request",
    "Unknown": "Unknown",
    "User signed in": "User signed in",
    "System maintenance task invoked": "System maintenance task invoked",
    "Updated a contact request": "Updated a contact request",
    "Two FA validation success": "Two FA validation success",
    "Changed a user status": "Changed a user status",
    "Two FA validation requested": "Two FA validation requested",
    "A new external contact request has been saved": "A new external contact request has been saved",
    "User failed to sign in": "User failed to sign in",
    "Created a follow-up for a meeting": "Created a follow-up for a meeting",
    "Uploaded a signature": "Uploaded a signature",
    "Changed his/her schedule": "Changed his/her schedule",
    "Updated a meeting": "Updated a meeting",
    "Attached files": "Attached files",
    "Upload": "Upload",
    "No files attached": "No files attached",
    "Include details": "Include details",
    "Signature": "Signature",
    "Import signature": "Import signature",
    "Downloaded a patient file": "Downloaded a patient file",
    "Uploaded a patient file": "Uploaded a patient file",
    "Old password": "Old password",
    "New password": "New password",
    "Confirm password": "Confirm password",
    "Change password required": "Change password required",
    "Length between 8 and 20 characters": "Length between 8 and 20 characters",
    "At least one lower case character": "At least one lower case character",
    "At least one upper case character": "At least one upper case character",
    "At least one numeric case character": "At least one numeric case character",
    "Password confirmation": "Password confirmation",
    "Change password": "Change password",
    "Password changed successfully": "Password changed successfully",
    "Please complete your profile": "Please complete your profile",
    "Restore": "Restore",
    "Profile changed successfully": "Profile changed successfully",
    "PHONE": "PHONE",
    "SMS": "SMS",
    "EMAIL": "EMAIL",
    "VOICE": "VOICE",
    "Invited a new user": "Invited a new user",
    "Changed a user name": "Changed a user name",
    "User changed his password": "User changed his password",
    "New signature saved": "New signature saved",
    "An error occured. Please check your old password": "An error occured. Please check your old password",
    "Contact requests list": "Contact requests list",
    "Transmitted": "Transmitted",
    "invalid format": "invalid format",
    "Security": "Security",
    "Today": "Today",
    "Meeting missed": "Meeting missed",
    "Are-you sure you want to mark this meeting as missed?": "Are-you sure you want to mark this meeting as missed?",
    "Complete follow-up": "Complete follow-up",
    "Are-you sure you want to complete the follow-up of this meeting?": "Are-you sure you want to complete the follow-up of this meeting?",
    "Link": "Link",
    "Google meet": "Google meet",
    "Microsoft Teams": "Microsoft Teams",
    "Zoom": "Zoom",
    "Meeting completed": "Meeting completed",
    "Absence": "Absence",
    "Cancel the absence": "Cancel the absence",
    "Are-you sure you want to cancel this absence?": "Are-you sure you want to cancel this absence?",
    "PAYMENT_RECEIPT": "Payment receipt",
    "No organization": "No organization",
    "Unconfirm presence": "Unconfirm presence",
    "Search": "Search",
    "Print contact request": "Print contact request",
    "Medication": "Medication",
    "Paid": "Paid",
    "Timesheet": "Timesheet",
    "All professionals": "All professionals",
    "Uncomplete follow-up": "Uncomplete follow-up",
    "Are-you sure you want to uncomplete the follow-up of this meeting?": "Are-you sure you want to uncomplete the follow-up of this meeting?",
    "Allow to uncomplete": "Allow to uncomplete",
    "Disallow to uncomplete": "Disallow to uncomplete",
    "In person": "In person",
    "Videoconference": "Videoconference",
    "Ext.": "Ext.",
    "Place": "Place",
    "Places": "Places",
    "Place name": "Place name",
    "Missing reports": "Missing reports",
    "Deactivate this patient?": "Deactivate this patient?",
    "Reactivate this patient?": "Reactivate this patient?",
    "With accounts": "With accounts",
    "Without accounts": "Without accounts",
    "Contractor": "Contractor",
    "Activate": "Activate",
    "Allowed": "Allowed",
    "Took": "Took",
    "Remaining": "Remaining",
    "Concurrency error": "Concurrency error",
    "Another screen appears to be opened for this follow-up. Please be sure to edit this follow-up in one place only.": "Another screen appears to be opened for this follow-up. Please be sure to edit this follow-up in one place only. If this is not the case, you can reopen this screen in 30 seconds or disregard this message.",
    "Documents": "Documents",
    "Evaluation": "Evaluation",
    "Evolution": "Evolution",
    "Final": "Final",
    "Note history": "Note history",
    "No available history": "No available history",
    "Apply note history?": "Apply note history?",
    "All patients": "All patients",
    "Consultation reason": "Consultation reason",
    "Event date": "Event date",
    "File number IVAC/CSST": "File number IVAC/CSST",
    "Mother": "Mother",
    "Father": "Father",
    "Other": "Other",
    "Relationship": "Relationship",
    "Apply": "Apply",
    "Parent 1": "Parent 1",
    "Parent 2": "Parent 2",
    "Your changes will be lost. Are you sure you want to leave this page?": "Your changes will be lost. Are you sure you want to leave this page?",
    "Primary": "Primary",
    "Secondary": "Secondary",
    "Remarks": "Remarks",
    "ANXIOUS": "Anxiety disorder",
    "PERSONALITY": "Personality disorder",
    "MOOD": "Mood disorder",
    "ADAPTATION": "Adaptation trouble",
    "PROFESSIONAL": "Professional issues",
    "COUPLE": "Relationship / couple issues",
    "FAMILY": "Relationship / family issues",
    "LEGAL": "Legal issues",
    "FINANCIAL": "Financial problems",
    "ADDICTION": "Substance addiction",
    "GAMBLING": "Gambling issues",
    "GRIEF": "Grief",
    "OTHER": "Others",
    "Consultation reasons": "Consultation reasons",
    "Suicidal ideation": "Suicidal ideation",
    "Name of treating doctor": "Name of treating doctor",
    "Allowed patients": "Allowed patients",
    "File imported successfully": "File imported successfully",
    "Import": "Import",
    "This patient is not authorized for this account": "This patient is not authorized for this account",
    "All accounts": "All accounts",
    "Professionals": "Professionals",
    "Previous": "Previous",
    "Personal note": "Personal note",
    "Save note model": "Save note model",
    "Model name": "Model name",
    "New model name": "New model name",
    "Remove note model": "Remove note model",
    "Are you sure you want to remove this note model?": "Are you sure you want to remove this note model?",
    "Missing cycle reports": "Missing cycle reports",
    "Unfinished cycles": "Unfinished cycles",
    "New contact requests": "New contact requests",
    "RAMQ Number": "RAMQ Number",
    "Expir. month": "Expir. month",
    "Expir. year": "Expir. year",
    "Informations": "Informations",
    "Contact": "Contact",
    "RAMQ": "RAMQ",
    "IVAC/CSST": "IVAC/CSST",
    "PSYCHIATRY": "Psychiatry service",
    "Service": "Service",
    "Paid meetings": "Paid meetings",
    "Unpaid meetings": "Unpaid meetings",
    "Inbound sms messages": "Inbound sms messages",
    "Export to excel": "Export to excel",
    "Statistics": "Statistics",
    "Rates": "Rates",
    "Payment receipts": "Payment receipts",
    "Include unpaid meetings": "Include unpaid meetings",
    "Amount paid": "Amount paid",
    "Identity": "Identity",
    "Licence number": "Licence number",
    "Tel.": "Tel.",
    "Service provided to": "Service provided to",
    "Missed meetings rates": "Missed meetings rates",
    "Rate": "Rate",
    "No meeting": "No meeting",
    "Administrative fees (24-hour cancellation or absence from the appointment)": "Administrative fees (less than 24 hour cancellation or absence from the appointment)",
    "Settings": "Settings",
    "Can be scheduled": "Visible on schedule",
    "Transfer to contractors": "Transfer to contractors",
    "Transfer to professionals": "Transfer to professionals",
    "The patient asked to cancel this meeting": "The patient asked to cancel this meeting",
    "on": "on",
    "at": "at",
    "Patient has answered to the meeting confirmation": "Patient has answered to the meeting confirmation",
    "A patient has confirmed their presence at an appointment": "A patient has confirmed their presence at an appointment",
    "A patient has requested the cancellation of an appointment": "A patient has requested the cancellation of an appointment",
    "Paid amount": "Paid amount",
    "Eligible employees": "Eligible employees",
    "Report viewer": "Report viewer",
    "Send report": "Send report",
    "Emails": "Emails",
    "Email subject": "Email subject",
    "Email body": "Email body",
    "Report sent successfully": "Report sent successfully",
    "An error occured while sending the report. Please try again.": "An error occured while sending the report. Please try again.",
    "Announcements": "Announcements",
    "Announcement": "Announcement",
    "Title": "Title",
    "Message": "Message",
    "Expiry": "Expiry",
    "Are you sure you want to delete this announcement?": "Are you sure you want to delete this announcement?",
    "Delete this announcement?": "Delete this announcement?",
    "Importance": "Importance",
    "Information": "Information",
    "Normal": "Normal",
    "Warning": "Warning",
    "Urgent": "Urgent",
    "New email": "New email",
    "Refresh": "Refresh",
    "Reply": "Reply",
    "Reply All": "Reply All",
    "Print email": "Print email",
    "Delete email": "Delete email",
    "Are you sure you want to delete this email?": "Are you sure you want to delete this email?",
    "Signed documents": "Signed documents",
    "Discard draft": "Discard draft",
    "Are you sure you want to discard your draft document?": "Are you sure you want to discard your draft document?",
    "Add document": "Add document",
    "Delete document": "Delete document",
    "Are you sure you want to delete this document? Patients will not be able to view it anymore.": "Are you sure you want to delete this document? Patients will not be able to view it anymore.",
    "Consignees": "Consignees",
    "Subject": "Subject",
    "Are you sure you want to discard your draft message?": "Are you sure you want to discard your draft email?",
    "No signed document configured": "No signed document configured",
    "No answer received": "No answer received",
    "Accept": "Accept",
    "Decline": "Decline",
    "You already accepted this document": "You already accepted this document",
    "You already declined this document": "You already declined this document",
    "Send on patient creation (only one document can be selected)": "Send on patient creation (only one document can be selected)",
    "Send document": "Send document",
    "Are you sure you want to send this document?": "Are you sure you want to send this document?",
    "Signed Documents": "Signed Documents",
    "Send documents": "Send documents",
    "Received answers": "Received answers",
    "Document sent successfully": "Document sent successfully",
    "Decline this document": "Decline this document",
    "Are you sure you want to decline this document?": "Are you sure you want to decline this document?",
    "Answer has been received. Thank you": "Answer has been received. Thank you",
    "Received without comm": "Received without comm",
    "Received with comm": "Received with comm",
    "Hours Summary": "Hours Summary",
    "Week": "Week",
    "Month": "Month",
    "Current": "Current",
    "Filter": "Filter",
    "Hours Follow-up": "Hours Follow-up",
    "Current (daily)": "Current (daily)",
    "Current (sum)": "Current (sum)",
    "Planned (daily)": "Planned (daily)",
    "Planned (sum)": "Planned (sum)",
    "Previous (daily)": "Previous (daily)",
    "Previous (sum)": "Previous (sum)",
    "Empty subject": "Empty subject",
    "You will send email to external contact": "You will send email to and external contact of your organization",
    "Next": "Next",
    "Submit": "Submit",
    "Previous_single": "Previous",
    "About you": "About you",
    "Q: Used service past": "Have you used our services in the past?",
    "Q: Requested service": "What service do you use our team for?",
    "Your comments and reasons for your request": "Your comments and reasons for your request",
    "Name of employer or organization": "Name of employer or organization",
    "Connection to the company or organization": "Connection to the company or organization",
    "Name of person employed by the company": "Name of person employed by the company",
    "How long have you been employed?": "How long have you been employed?",
    "Directed to EAP": "Directed to EAP",
    "Confirmation number": "Confirmation #",
    "Thank you for contacting us": "Thank you for contacting us",
    "Here is your confirmation number": "Here is your confirmation number",
    "A patient arrived": "A patient arrived",
    "Welcome": "Welcome",
    "Please enter your meeting code here": "Please enter your meeting code here",
    "Thank you! Please have a seat": "Thank you! Please have a seat",
    "Sorry, this code is not valid": "Sorry, this code is not valid",
    "Return": "Return",
    "MALE": "Man",
    "FEMALE": "Woman",
    "NON_BINARY": "Non-binary",
    "Gender": "Gender",
    "Access to notes": "Access to notes",
    "24H": "24H",
    "Patient portal": "Patient portal",
    "Has access": "Has access",
    "Doesn't has access": "Doesn't has access",
    "Remove access": "Remove access",
    "Access removed successfully": "Access removed successfully",
    "Access granted successfully": "Access granted successfully",
    "transactions": "transactions",
    "Add transaction": "Add transaction",
    "Remove Transaction": "Remove Transaction",
    "Are you sure you want to remove this transaction?": "Are you sure you want to remove this transaction?",
    "Amount": "Amount",
    "Transactions": "Transactions",
}
export default local_en;
